import React from 'react';
import DHRouter from '~/components/atom/DHRouter';
import OfficeList from './components/OfficeList';
import OfficeUserList from './components/OfficeUserList';
import OfficeDetails from './components/OfficeDetails';
import WorkingArea from './components/WorkingArea';
import type { RouteComponentProps } from '@gatsbyjs/reach-router';

const Offices: React.FC<RouteComponentProps> = () => (
  <DHRouter>
    <OfficeList path="/" />
    <OfficeDetails path="/:officeId" />
    <OfficeUserList path="/:officeId/users" />
    <WorkingArea path="/:officeId/working-area" />
  </DHRouter>
);

export default Offices;
